import './styles.css';
import { initCalculator } from './calculator';
import { initConsent } from './consent';
import { initFormGuard } from './form-guard';
import { initLookups } from './lookup';
import { initKnowledgeBaseSearch } from './knowledge-base';

document.documentElement.classList.add('js');

const navToggle = document.querySelector<HTMLButtonElement>('[data-nav-toggle]');
const siteNav = document.querySelector<HTMLElement>('#site-nav');
if (navToggle && siteNav) {
    navToggle.addEventListener('click', () => {
        const open = siteNav.classList.toggle('open');
        navToggle.setAttribute('aria-expanded', String(open));
    });
}

document.querySelectorAll<HTMLFormElement>('form[data-guard]').forEach(initFormGuard);

const calc = document.querySelector<HTMLElement>('.calculator');
if (calc) initCalculator(calc);

const startForm = document.querySelector<HTMLElement>('[data-startmonth-form]');
if (startForm) {
    initCalculator(startForm);
    initLookups(startForm as HTMLFormElement);
    initFormSteps(startForm);
}

function initFormSteps(form: HTMLElement): void {
    const steps = Array.from(form.querySelectorAll<HTMLElement>('[data-form-step]'));
    if (steps.length === 0) return;

    const stepper = document.querySelector<HTMLElement>('.stepper');
    const stepperItems = stepper ? Array.from(stepper.querySelectorAll<HTMLElement>('.stepper__item')) : [];

    // The funnel starts at step 3 (steps 1+2 are handled server-side)
    const stepOffset = 2;

    function updateStepper(activeFormStepNum: number): void {
        const activeOverall = activeFormStepNum + stepOffset;
        stepperItems.forEach((item, i) => {
            const n = i + 1;
            item.classList.remove('is-done', 'is-active', 'is-todo');
            if (n < activeOverall) {
                item.classList.add('is-done');
                item.removeAttribute('aria-current');
            } else if (n === activeOverall) {
                item.classList.add('is-active');
                item.setAttribute('aria-current', 'step');
            } else {
                item.classList.add('is-todo');
                item.removeAttribute('aria-current');
            }
        });
    }

    function showStep(index: number): void {
        steps.forEach((s, i) => {
            if (i === index) {
                s.removeAttribute('hidden');
            } else {
                s.setAttribute('hidden', '');
            }
        });
        const stepNum = parseInt(steps[index].dataset.formStep ?? '3', 10) - stepOffset;
        updateStepper(stepNum);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function fillPackageSummary(): void {
        const summaryEl = form.querySelector<HTMLElement>('[data-package-summary]');
        if (!summaryEl) return;

        const moduleBoxes = Array.from(form.querySelectorAll<HTMLInputElement>('[data-calc-module]:checked'));
        const modulesEl = summaryEl.querySelector<HTMLElement>('[data-summary-modules]');
        const priceEl = summaryEl.querySelector<HTMLElement>('[data-summary-price]');
        const totalEl = form.querySelector<HTMLElement>('[data-calc="total"]');

        if (modulesEl) {
            const names = moduleBoxes.map(b => b.closest('label')?.textContent?.trim() ?? b.dataset.calcModule ?? '').filter(Boolean);
            modulesEl.textContent = names.length ? names.join(', ') : 'Alleen basispakket';
        }
        if (priceEl && totalEl) {
            priceEl.textContent = (totalEl.textContent ?? '') + ' per maand, excl. btw';
        }

        summaryEl.removeAttribute('hidden');
    }

    // Wire up "Volgende" and "Terug" buttons
    steps.forEach((step, index) => {
        step.querySelector<HTMLButtonElement>('[data-form-next]')?.addEventListener('click', () => {
            const inputs = Array.from(step.querySelectorAll<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>('input,textarea,select'));
            const invalid = inputs.find(el => !el.checkValidity());
            if (invalid) { invalid.reportValidity(); return; }
            if (index + 1 < steps.length) {
                showStep(index + 1);
                if (steps[index + 1].dataset.formStep === '5') fillPackageSummary();
            }
        });
        step.querySelector<HTMLButtonElement>('[data-form-prev]')?.addEventListener('click', () => {
            if (index > 0) showStep(index - 1);
        });
    });

    // Start on step index 0 (already visible, but sync the stepper)
    const initialStepNum = parseInt(steps[0].dataset.formStep ?? '3', 10) - stepOffset;
    updateStepper(initialStepNum);
}

const banner = document.querySelector<HTMLElement>('[data-consent-banner]');
const ga4Id = document.body.dataset.ga4 ?? '';
if (banner) initConsent(banner, ga4Id);

initKnowledgeBaseSearch();
